import { useQuery } from "hooks/useQuery";
import { getPortfolioData } from "features/Dashboard/service";

export const usePortfolioData = (portfolioId, enabled = true) => {
  const { isLoading, data, refetch } = useQuery({
    key: "portfolioData",
    queryKey: ["portfolioData", portfolioId],
    queryFn: async () => {
      const response = await getPortfolioData(portfolioId);
      return response;
    },
    enabled: !!portfolioId && enabled,
  });

  return {
    isLoading,
    portfolioData: data,
    refetch,
  };
};
